export default "/static/03f07f59716b71fc.svg"